/**
 * Rounds a number to the specified number of significant places *
 */
export const roundDecimal = (number, places) => {
  number = Number(number);
  places = typeof places === 'number' ? places : 0;
  if (places <= 0) {
    return Math.round.call(null, number);
  }
  const significant = Math.pow(10, places),
    insignificant = Number('1e+' + (places + 1)),
    decimal = (Math.round.call(null, number * significant + insignificant) - insignificant) / significant;
  return decimal;
};
/**
 * Formats a number
 */
export const formatDecimal = (number, options) => {
  options = options || {};
  number = typeof number === 'undefined' ? 0 : number;
  number = Number(number);
  let formatted;
  if (options.places) {
    formatted = roundDecimal(number, options.places).toFixed(options.places);
  } else {
    formatted = number;
  }
  formatted = formatted.toString();
  if (options.separator) {
    formatted = formatted.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + options.separator);
  }
  return formatted;
};